import clsx from 'clsx'
import { Icon } from '@iconify/react'
import { Button } from '@pepper/ui'

import s from './BottomPopup.module.css'

type ButtonProps = {
  children?: React.ReactNode
  onClick?: () => void
  type?: 'default' | 'delete'
  icon?: React.ReactNode
  iconPlacement?: 'left' | 'right'
  isLoading?: boolean
  disabled?: boolean
}

export const BottomPopupBtn = ({
  children,
  onClick,
  type = 'default',
  icon,
  iconPlacement,
  isLoading,
  disabled,
}: ButtonProps) => {
  return type === 'default' ? (
    <Button
      size="small"
      className={s.btn}
      onClick={onClick}
      icon={icon}
      iconPlacement={iconPlacement}
      loading={isLoading}
      disabled={disabled}
    >
      {children}
    </Button>
  ) : (
    <Button
      loading={isLoading}
      disabled={disabled}
      size="small"
      className={s.deleteBtn}
      onClick={onClick}
      icon={<Icon icon="lucide:trash-2" width={14} height={14} />}
    />
  )
}

type Props = {
  children: React.ReactNode
  selectedCount: number
  onClose: () => void
  infoMessage?: string
  align?: 'right' | 'center'
}

export const BottomPopup = ({
  children,
  selectedCount,
  onClose,
  align = 'center',
  infoMessage,
}: Props) => {
  if (!selectedCount) return null

  return (
    <div className={clsx(s.wrapper, s[align])}>
      <div className={s.content}>
        <span className={s.text}>{selectedCount} selected</span>
        <span className={s.btnWrapper}>{children}</span>
      </div>
      <button className={s.closeBtn} onClick={onClose}>
        <Icon icon="lucide:x" />
      </button>
      {infoMessage && (
        <span className={s.info}>
          <Icon
            icon="lucide:info"
            className={s.infoIcon}
            width={14}
            height={14}
          />
          {infoMessage}
        </span>
      )}
    </div>
  )
}
